// extracted by mini-css-extract-plugin
module.exports = {"loading-document":"loading-document_loading-document__cUrLY","text":"loading-document_text__s5I_o"};